import { render } from "./SectionPaymentReleasing.vue?vue&type=template&id=5b0d7c7c&scoped=true"
import script from "./SectionPaymentReleasing.vue?vue&type=script&lang=js"
export * from "./SectionPaymentReleasing.vue?vue&type=script&lang=js"

import "./SectionPaymentReleasing.vue?vue&type=style&index=0&id=5b0d7c7c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0d7c7c"]])

export default __exports__